import styled from 'styled-components'
import { Noto_body2_r14 } from 'src/styles/fonts/NotoSansKrFonts'

const SplashNotiModal = ({ contents }: { contents: string }) => {
  return <SplashNotiModalContents dangerouslySetInnerHTML={{ __html: contents }} />
}
export default SplashNotiModal

const SplashNotiModalContents = styled.p`
  ${Noto_body2_r14};
  text-align: center;
  white-space: pre-wrap;
  overflow-y: scroll;
  padding: 10px 10px 30px 10px;
`
